import { React } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useRecoilValue, useRecoilState } from "recoil";
import { isLoginAtom, isModalAtom, usersAtom } from "../atoms";
import { useUserActions } from "../functions/useUserActions";

function Header() {
  //현재위치 파악
  const pathName = useLocation().pathname;

  // 모달창 - 모달상태 + 모달호출
  const [, setisMocalopen] = useRecoilState(isModalAtom);
  const handleShow = (params) => setisMocalopen(params);

  //login status
  const loginstat = useRecoilValue(isLoginAtom);
  const userActions = useUserActions();
  const authdata = useRecoilValue(usersAtom);
  /*
  useEffect(() => {
    const storageData = localStorage.getItem("user");
    let expiryDate = null;

    if (storageData !== null) {
      try {
        const userData = JSON.parse(storageData);
        expiryDate = userData.accessTokenExpiresIn;
        if (expiryDate && new Date(expiryDate) < new Date()) {
          userActions.logout();
        }
      } catch (error) {
        console.error("Failed to parse storage data:", error);
      }
    }
  }, [userActions]);
*/
  return (
    <nav
      className="navbar navbar-expand-sm bg-dark bg-opacity-75 navbar-dark "
      style={{ minHeight: "5vh", maxHeight: "5vh" }}
    >
      <div className="container-fluid">
        <Link to="/">
          <img
            className="img-fluid"
            src={`${process.env.PUBLIC_URL}/logo_transparent.png`}
            width="40%"
            height="30%"
            alt="logo with erp"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapsibleNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-end"
          id="collapsibleNavbar"
        >
          <div
            className="collapse navbar-collapse flex-column ml-lg-0 ml-3"
            id="navbarCollapse"
          ></div>
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link
                to="/"
                className={pathName === "/" ? "nav-link active" : "nav-link"}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/board"
                className={
                  pathName === "/board" ? "nav-link active" : "nav-link"
                }
              >
                Board
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/board2"
                className={
                  pathName === "/board2" ? "nav-link active" : "nav-link"
                }
              >
                Board2
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/test"
                className={
                  pathName === "/test" ? "nav-link active" : "nav-link"
                }
              >
                Test
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/"
                className={pathName === "/" ? "nav-link active" : "nav-link"}
              >
                DB_Test
              </Link>
            </li>
            <li className="nav-item">
              {loginstat ? (
                <Button
                  variant=" btn-outline-primary"
                  onClick={() => {
                    handleShow("user");
                  }}
                >
                  {JSON.stringify(authdata)}
                </Button>
              ) : (
                ""
              )}
            </li>
            <li className="nav-item">
              {loginstat ? (
                <Button
                  variant=" btn-outline-primary"
                  onClick={() => {
                    userActions.logout();
                  }}
                >
                  로그아웃
                </Button>
              ) : (
                <Button
                  variant=" btn-outline-primary"
                  onClick={() => {
                    handleShow("login");
                  }}
                >
                  로그인/회원가입
                </Button>
              )}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
export default Header;
